<button mat-button class="select" (click)="openSearchUser()" [ngStyle]="style">
  利用者選択
  <div class="mat-select-arrow-wrapper">
    <div class="mat-select-arrow"></div>
  </div>
</button>